import { render, staticRenderFns } from "./FollowingProductionTableView.vue?vue&type=template&id=32232dd2&scoped=true&"
import script from "./FollowingProductionTableView.vue?vue&type=script&lang=js&"
export * from "./FollowingProductionTableView.vue?vue&type=script&lang=js&"
import style0 from "./FollowingProductionTableView.vue?vue&type=style&index=0&id=32232dd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32232dd2",
  null
  
)

export default component.exports